import type { FaireProductEntity } from "../../entity_types/product";

export const p_35qdg045: FaireProductEntity = {
  token: "p_35qdg045",
  type: "product",
  name: "Really Happy Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/daab39bed8c33f2c6784823fdf6062eb706ffca7731b550eb9b4a855eb2c9d11.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e3988bd07cf263ab05eefab4e5aff037e2d6ddafa11f7dc03da709edf95115ec.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:30.009Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
